import { NSARouterMakerResult } from "namirasoft-account-react";
import { CostLayout } from "../CostLayout";
import { CostEntities } from "../CostEntities";
import { CostRouterProps } from "../CostRouterProps";

interface CostListPageProps extends NSARouterMakerResult, CostRouterProps { }

function CostListPage(props: CostListPageProps)
{
    return (
        <CostLayout
            {...props}
            action={{
                description: "This section displays a list of all recorded costs for your account with basic details for each entry.",
            }}
            pages={{
                entity: CostEntities.cost(props, []),
                list: {
                    ui: {
                        tab_page_view: {
                            tabs: {
                                history: false
                            }
                        }
                    }
                },
            }}
        >
            <></>
        </CostLayout>
    );
}
export default CostListPage;